import React from 'react'

import { ROUTE_URLS } from 'router/routes'

import { BonusPromotionStatus } from 'shared/models/Promotion'
import { UpgamingSportPages } from 'shared/models/Upgaming'

import { ReactComponent as CasinoIcon } from 'components/SideMenu/SideMenuLeftContent/img/casino.svg'
import { ReactComponent as LiveIcon } from 'components/SideMenu/SideMenuLeftContent/img/live.svg'
import { ReactComponent as LiveCasinoIcon } from 'components/SideMenu/SideMenuLeftContent/img/live-casino.svg'
import { ReactComponent as SportIcon } from 'components/SideMenu/SideMenuLeftContent/img/sport.svg'

export interface INavigationItem {
  text: string
  route: string
  mobileRoute?: string
  icon?: string
  svg?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  modalRoute?: string
  isAuthReq?: boolean
  isNew?: boolean
  isTopGame?: boolean
  isModalForMobile?: boolean
  isMobile?: boolean
  subItems?: string[]
}

export const navigationItems: INavigationItem[] = [
  {
    text: 'sport',
    route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME),
    svg: SportIcon,
  },
  {
    text: 'live',
    route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.LIVE),
    svg: LiveIcon,
  },
  { text: 'casino', route: ROUTE_URLS.SLOTS('casino'), svg: CasinoIcon },
  { text: 'liveCasino', route: ROUTE_URLS.SLOTS('live-casino'), svg: LiveCasinoIcon },
]

export const sidemenuHistoryItems: INavigationItem[] = [
  { text: 'betsHistory', route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.BET_HISTORY) },
  { text: 'slotsHistory', route: ROUTE_URLS.PROFILE_SLOTS_HISTORY() },
  // { text: 'spinHistory', route: ROUTE_URLS.PROFILE_SPIN_HISTORY() },
  { text: 'transactionsHistory', route: ROUTE_URLS.PROFILE_TRANSACTIONS() },
]

export const sidemenuSettingsItems: INavigationItem[] = [
  { text: 'personalInformation', route: ROUTE_URLS.PROFILE_USERINFO() },
  { text: 'changePassword', route: ROUTE_URLS.PROFILE_CHANGE_PASSWORD() },
  { text: 'exchangeBonus', route: ROUTE_URLS.PROFILE_EXCHANGE_BONUS_BALANCE() },
  { text: 'promotions', route: ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.active) },
]
